import { useEffect } from 'react';
import { useIntercom } from 'react-use-intercom';

// Keep in sync with the breakpoint in libs/ui-ds-base/src/lib/modal/modal.tsx (bottom drawer below it).
const MOBILE_MEDIA_QUERY = '(max-width: 767px)';
// Drives the rule in apps/worker-app/styles/GlobalStyles.tsx that hides the launcher markup.
export const SAVE_SEARCH_OPEN_BODY_CLASS = 'save-search-modal-open';

/**
 * While the save-search drawer is open on a phone, hide the Intercom launcher: it sits over the
 * drawer's footer button (Edoardo, 19/10/2026). Same approach as the assessment chat: a body class
 * for the markup Intercom already rendered, plus `hideDefaultLauncher` on the Messenger, issued in a
 * macrotask so a boot in the same commit cannot overwrite it.
 */
export const useHideIntercomLauncherOnMobile = (active: boolean) => {
  const { update } = useIntercom();
  useEffect(() => {
    if (!active || typeof window === 'undefined' || !window.matchMedia(MOBILE_MEDIA_QUERY).matches) return;
    document.body.classList.add(SAVE_SEARCH_OPEN_BODY_CLASS);
    const timer = window.setTimeout(() => update({ hideDefaultLauncher: true }), 0);
    return () => {
      window.clearTimeout(timer);
      document.body.classList.remove(SAVE_SEARCH_OPEN_BODY_CLASS);
      update({ hideDefaultLauncher: false });
    };
  }, [active, update]);
};
